angular.module('lf.common')

.controller('PasswordRecoveryCtrl', function ($scope, accountService) {

  $scope.form = {};
  
  $scope.error = null;
  
  $scope.recoverPassword = function () {
    $scope.requesting = true;
    $scope.newPasswordSent = false;
    $scope.error = null;
    
    accountService.resetPassword($scope.form)
      .success(function (data) {
        var data = data && data.data;
        
        if (data && data.success) {
          $scope.newPasswordSent = true;
        } else {
          $scope.error = {};
          if (data && data.error && data.error.message) {
            $scope.error.message = data.error.message;
          } else {
            $scope.error.serverError = true;
          }
        }
      })
      .error(function () {
        $scope.error = { serverError: true };
      })
      .finally(function () {
        $scope.requesting = false;
      });
  }

});
